var ApiRenderComponents = /* @__PURE__ */ ((ApiRenderComponents2) => {
  ApiRenderComponents2["menu"] = "menu";
  return ApiRenderComponents2;
})(ApiRenderComponents || {});
var ApiRenderComponentMenu = /* @__PURE__ */ ((ApiRenderComponentMenu2) => {
  ApiRenderComponentMenu2["header"] = "header";
  ApiRenderComponentMenu2["top"] = "top";
  return ApiRenderComponentMenu2;
})(ApiRenderComponentMenu || {});
var ApiRenderComponentMenuView = /* @__PURE__ */ ((ApiRenderComponentMenuView2) => {
  ApiRenderComponentMenuView2["asia"] = "asia";
  ApiRenderComponentMenuView2["base"] = "base";
  return ApiRenderComponentMenuView2;
})(ApiRenderComponentMenuView || {});
export {
  ApiRenderComponentMenu,
  ApiRenderComponentMenuView,
  ApiRenderComponents
};
